export default __webpack_public_path__ + "static/media/easy-web-app.a8f013ff.mp4";